// The record keys the Company form edits, in one place so the form's autosave
// signature, the Owner page and the SuperAdmin page cannot drift apart.
export const COMPANY_FIELDS = [
  "name",
  "timezone",
  "email",
  "billing_contact_name",
  "billing_contact_phone",
  "billing_address_line1",
  "billing_address_line2",
  "billing_address_city",
  "billing_address_state",
  "billing_address_postal_code",
  "billing_address_country",
  "address_line1",
  "address_line2",
  "address_city",
  "address_state",
  "address_postal_code",
  "address_country",
  "address_phone",
];
